// OwnerProtectedRoute.js
import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { OwnerAuthContext } from "../../../contexts/OwnerAuthContext";

const OwnerProtectedRoute = () => {
  const { owner, ownerLoading, ownerSessionChecked } = useContext(OwnerAuthContext);
  const location = useLocation();

  if (!ownerSessionChecked || ownerLoading) {
    return (
      <div
        className="min-h-screen flex flex-col items-center justify-center gap-4 bg-surface"
        role="status"
        aria-live="polite"
      >
        <div className="w-10 h-10 border-2 border-brand border-t-transparent rounded-full animate-spin" />
        <p className="text-gray-600 font-medium">Vérification de la session...</p>
      </div>
    );
  }

  if (!owner) {
    return (
      <Navigate
        to="/restaurant/login"
        state={{ from: location.pathname, redirectBack: true }}
        replace
      />
    );
  }

  return <Outlet />;
};

export default OwnerProtectedRoute;
